import { cn } from "@/utils/cn";
import type { CardProps } from "./Card.types";

type CardStyleProps = Pick<CardProps, "className" | "withShadow">;

export const getCardStyles = ({ className, withShadow }: CardStyleProps) => {
  return {
    wrapper: cn(
      "overflow-hidden rounded-[8px] bg-dark-500",
      {
        "shadow-lg": withShadow,
      },
      className
    ),
    header: cn("p-4 border-b border-dark-300", "flex items-center justify-between gap-4"),
    title: "text-lg font-semibold text-primary-100",
    body: "p-4",
    footer: "p-4 border-t border-dark-300",
    closeButton: cn(
      "flex-shrink-0 text-dark-100 hover:text-primary-100",
      "p-1 rounded-full hover:bg-dark-300", // Fundo sutil no hover
      "transition-colors duration-200"
    ),
  };
};
